/**
 * The ONE resolver for a class's provider-contact facts (business name, pinned address, location
 * phone). This block drifted three formats across surfaces before being consolidated -- every
 * surface must resolve through here so they can't diverge again.
 *
 * @param {Object} listing the listing entity (with author included when available)
 * @param {Object} [provider] an explicitly-fetched provider user (the transaction page has one);
 *   falls back to listing.author
 * @returns {{ businessName: string|null, address: string|null, phone: string|null }}
 */
export const getClassContact = (listing, provider = null) => {
  const publicData = listing?.attributes?.publicData || {};
  const providerUser = provider || listing?.author || null;
  const profile = providerUser?.attributes?.profile || {};
  const businessName = profile.publicData?.businessName || profile.displayName || null;

  const locations =
    profile.publicData?.locations ||
    listing?.author?.attributes?.profile?.publicData?.locations ||
    [];
  const pinned = Array.isArray(locations)
    ? locations.find(l => l && l.id === publicData.locationId) || null
    : null;

  const address = publicData.location?.address || pinned?.address || null;
  const phone =
    typeof pinned?.phone === 'string' && pinned.phone.trim() ? pinned.phone.trim() : null;
  return { businessName, address, phone };
};
